/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
    <div :class="addFadeIn ? 'mc-banner-gratuity fade-in-badge' : 'mc-banner-gratuity'">
      <div v-html="gratuity.template">

      </div>
      <ion-fab style="display: flex;" horizontal="end" slot="fixed">
        <ion-fab-button v-on:click="close" color="secondary">
          <ion-icon name="close"></ion-icon>
        </ion-fab-button>
      </ion-fab>
    </div>


</template>

<style lang="scss">
.mc-banner-gratuity {
  position: relative;
  z-index: 1;
  padding: 10px;
  margin: 10px;
  margin-bottom: 50px;
  background: white;
  border-radius: 30px;
  border: 2px solid var(--ion-color-secondary);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 5px -1px, rgba(0, 0, 0, 0.14) 0px 6px 10px 0px, rgba(0, 0, 0, 0.12) 0px 1px 18px 0px;
  p {
    font-size: 0.9rem;
    margin : 5px;

    color: #000000;
  }
}
</style>

<script>
export default {
  name: "gratuity-completed-action",
  props: ['gratuity'],
  data: function() {
    return {
      addFadeIn: false
    };
  },
  created() {
    this.changeFadeIn();
  },
  methods: {
    changeFadeIn() {
      this.addFadeIn = true;
    },
    close() {
      this.$store.commit('remove_displayed_gratuities', this.gratuity);
    }
  }
};
</script>
